import { useExpertSkillsSummaryData } from "@/data/use-expert-skills-summary-data";
import { useGroupSkillsData } from "@/data/use-group-skills-data";
import { useSkillsData } from "@/data/use-skills-data";
import { useGroupUuid } from "@/hooks/use-group-uuid";
import { useKitUuid } from "@/hooks/use-kit-uuid";
import { useMemo } from "react";
import { ExpertSkillsSection } from "./ExpertSkillsSection";
import { SkillPickerPools, toSkillSummary } from "./skills-picker-lib";

export const SingleExpertSkillsSection: React.FC<{
  expertUuid: string;
  onSelect: (input: { skillUuid: string }) => void;
}> = ({ expertUuid, onSelect }) => {
  const groupUuid = useGroupUuid();
  const kitUuid = useKitUuid();
  const { skills: expertSkills } = useExpertSkillsSummaryData(
    groupUuid,
    expertUuid,
  );
  const { skills: kitSkills } = useSkillsData(groupUuid, kitUuid);
  const { skills: groupSkills } = useGroupSkillsData({
    groupUuid,
  });

  const pools = useMemo((): SkillPickerPools => {
    // Grant `access` only governs editability on the Artifacts page; every
    // skill on the kit (however it got there) belongs in this picker.
    const kitOnlySkills = kitSkills.map(toSkillSummary);
    const kitOnlySkillUuids = new Set(kitOnlySkills.map((skill) => skill.uuid));

    return {
      expertSkills,
      kitOnlySkills,
      groupSkills: groupSkills
        .filter((skill) => !kitOnlySkillUuids.has(skill.uuid))
        .map(toSkillSummary),
    };
  }, [expertSkills, kitSkills, groupSkills]);

  return <ExpertSkillsSection pools={pools} showGroup onSelect={onSelect} />;
};
